// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/app/index.scss
// module id = 827
// module chunks = 0